// extracted by mini-css-extract-plugin
export default {"container":"CampaignStatus_container__euh11","row":"CampaignStatus_row__iuYMP"};